import { render, staticRenderFns } from "./aboutLxmlItem.vue?vue&type=template&id=c14a1432&scoped=true&"
import script from "./aboutLxmlItem.vue?vue&type=script&lang=js&"
export * from "./aboutLxmlItem.vue?vue&type=script&lang=js&"
import style0 from "./aboutLxmlItem.vue?vue&type=style&index=0&id=c14a1432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14a1432",
  null
  
)

export default component.exports